module.exports = __webpack_public_path__ + "static/media/palm.35e82d39.svg";